export default {
  EVERGREEN: "Evergreen",
  FEATURED: "Featured",
  LIMITED: "Limited",
  MONTHLY: "Monthly",
};
